import ZkTable from './Table/Table';

ZkTable.install = (Vue) => {
  Vue.component(ZkTable.name, ZkTable);
};

export default ZkTable;



// WEBPACK FOOTER //
// ./src/index.js